import { AbstractModel } from '../../../shared/abstract.model';

/**
 * Model describing comment object
 */
export class Comment extends AbstractModel {
  /**
   * Id of the notification
   */
  notificationId: number;
  /**
   * Comment
   */
  comment: string;
  /**
   * user id
   */
  userId: string;

  constructor() {
    super();
    this.id = null;
  }
}

